import request from '@/utils/request';

export function getList(data) {
  return request({
    url: '/customers/load',
    method: 'post',
    data
  });
}

export function loadForRole(roleId) {
  return request({
    url: '/customers/loadForRole',
    method: 'get',
    params: { appId: '', firstId: roleId }
  });
}

export function add(data) {
  return request({
    url: '/customers/add',
    method: 'post',
    data
  });
}

export function update(data) {
  return request({
    url: '/customers/update',
    method: 'post',
    data
  });
}

export function del(data) {
  return request({
    url: '/customers/delete',
    method: 'post',
    data
  });
}

export function get(id) {
  return request({
    url: '/customers/Get',
    method: 'get',
    params: { id: id }
  });
}

export function getloadfile(data) {
  return request({
    url: '/customers/GetLoadFile',
    method: 'post',
    responseType: 'arraybuffer',
    data
  });
}
